export const RELATIONSHIPS = [
  { text: 'Self', value: 'Self' },
  { text: 'Spouse', value: 'Spouse' },
  { text: 'Dependent', value: 'Dependent' },
  { text: 'Other', value: 'Other' },
]
